var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentlyPlayingLogo = function SvgCurrentlyPlayingLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.649 0H5.682v4.066h8.882L18.65 0Z",
    fill: "#FF1480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.651 4.066V0l-4.085 4.066h4.085Z",
    fill: "#FFD400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.65 5.742V4.066h-4.075L11.03 7.61l-.55.55c-.261.354-.109.732 0 .876l2.428 2.428h.02l5.722-5.723Z",
    fill: "#00F2C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.098 8.372A6.811 6.811 0 1 1 5.471 13.19H9.75a2.532 2.532 0 1 0 4.322-1.79l3.026-3.027ZM4.739 19.73V0L1.232.01C.78.039.5.53.5.76v18.97h4.239Z",
    fill: "#F0F0F0"
  })));
};
export default SvgCurrentlyPlayingLogo;